import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { statuses, oppStatus } from 'src/app/common/events/status.service';
@Component({
  selector: 'app-view-lead-popup',
  templateUrl: './view-lead-popup.component.html',
  styleUrls: ['./view-lead-popup.component.css']
})
export class ViewLeadPopupComponent implements OnInit {
  @Input() leadStatus: number;
  @Input() statusSelected: any;
  @Input() oppStatus:number;
  @Input() remarks:any;
  dropStatus:any;
  user: {
    status: number;
    date: string;
    remarks: string;
    actualProductCost: string;
    opportunityStatus: number
  } = {
      status: 0,
      date: '',
      remarks: '',
      actualProductCost: '',
      opportunityStatus:0
    };


  statusValues = statuses
  minDateTime: string;
  oppStatusValues = oppStatus
  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    if(this.statusSelected) {
      this.user.status = this.statusSelected
      this.user.remarks = this.remarks
    }
    if(this.oppStatus) {
      if(this.oppStatus === 5) {
        this.user.status=12
      }
      this.user.opportunityStatus = this.oppStatus
    }
     const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');

  // Format: YYYY-MM-DDTHH:mm (HTML5 datetime-local format)
  this.minDateTime = `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  close(): void {
    this.activeModal.dismiss();
  }

  toNumber(value: any): number {
    return Number(value);
  }

  changeDrop(event:Event) {
      const selectedValue = (event.target as HTMLSelectElement).value;
      this.dropStatus = Number(selectedValue)
      this.user.status = Number(selectedValue)
      if(this.user.status === 9) {

      }
      
  }

   changeOppDrop(event:Event) {
      const selectedValue = (event.target as HTMLSelectElement).value;
      this.dropStatus = selectedValue
      
  }

  // submit(): void {
  //   alert("getting")
  //   if (this.user.status && this.user.date) {
  //     this.activeModal.close(this.user);
  //   } else {
  //     alert('Please fill in all required fields.');
  //   }
  // }
  submit(): void {
    if (!this.user.status) {
      return;
    }

    if (this.user.status === 5 && !this.user.date) {
      return;
    }
    this.activeModal.close(this.user);
  }
}
